import styled from "styled-components";



export const StyledLoginForm  = styled.div`
width: 500px;
/* height: 40rem; */
background: #ffffff;
border-radius: 11.7554px;
/* margin-left: 4rem; */
margin-top: 5rem;
display: flex;
align-items: center;
justify-content: center;
.content {
  padding-top: 20px;
  width: 85%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 2rem;
  box-sizing: border-box;
  .title {
    font-family: "Ubuntu";
    font-style: normal;
    font-weight: 400;
    font-size: 27.0939px;
    line-height: 32px;
    color: #20a8d3;
  }
}
`;

